import { RoutesMap } from '@Router/router.types';
import { CddEmbeddedFields } from '../../../../eddQuestions/pages/direct/field.types';
import { createUseCddLogic } from '../../../common/useCddLogic';
import type { CddDataFull, CddVolumeOptions } from '../../../common/api/cdd.api.types';
import type { CddVolumesFormValues } from '../../../common/formatCddDataToFormValues';

const formatCddDataToFormValues = (data: CddDataFull | undefined): CddVolumesFormValues => ({
  [CddEmbeddedFields.CDD_ACH_VOLUMES_INCOMING]: data?.achIncoming ?? '',
  [CddEmbeddedFields.CDD_ACH_VOLUMES_OUTGOING]: data?.achOutgoing ?? '',
});

export const useCddAchLogic = createUseCddLogic({
  schemaTitle: 'CddAchVolumes',
  route: RoutesMap.CDD_ACH_VOLUMES,
  questionOneFieldName: CddEmbeddedFields.CDD_ACH_VOLUMES_INCOMING,
  questionTwoFieldName: CddEmbeddedFields.CDD_ACH_VOLUMES_OUTGOING,
  formatCddDataToFormValues,
  getPayload: (values) => ({
    achIncoming: values[CddEmbeddedFields.CDD_ACH_VOLUMES_INCOMING] as CddVolumeOptions,
    achOutgoing: values[CddEmbeddedFields.CDD_ACH_VOLUMES_OUTGOING] as CddVolumeOptions,
  }),
});
